<template>
    <div class="table-container">
        <div class="title">
            <span>
                Test Lists List
            </span>
            <div>
                <v-btn :disabled="!hasCreatePrivilege" class="edit-btn" @click="goToCreateTestList">
                    Add Test List
                </v-btn>
            </div>
        </div>
        <array-view
            :items="testLists"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :is-fetching="isFetchingTestLists"
            :is-edit-disabled="!hasEditPrivilege"
            :is-delete-disabled="!hasDeletePrivilege"
            @paginationChange="paginationChange"
            @updateTestList="updateTestList"
            @deleteTestList="deleteTestList"
        />
    </div>
</template>

<script>
    import testListService from '@/services/test-list-service'
    import ArrayView from '@/components/ArrayView'
    import { hasPrivilege } from '@/utils/userUtils'
    import { PRIVILEGES } from '@/utils/consts'
    export default {
        components: { ArrayView },
        data() {
            return {
                headers: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Name',
                        value: 'name'
                    },
                    {
                        text: 'Actions',
                        align: 'center',
                        value: 'actions',
                        sortable: false
                    }
                ],
                testLists: [],
                totalPages: 0,
                size: 5,
                page: 1,
                sortKey: 'id',
                sortOrder: 'ASC',
                isFetchingTestLists: false
            }
        },
        computed: {
            hasEditPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.TESTLIST_UPDATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasDeletePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.TESTLIST_DELETE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasCreatePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.TESTLIST_CREATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            }
        },
        watch: {
            page: 'applyFiltersToQuery',
            size: 'applyFiltersToQuery',
            sortKey: 'applyFiltersToQuery',
            sortOrder: 'applyFiltersToQuery'
        },
        created() {
            this.initializeFilters()
            this.fetchAllTestLists()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllTestLists()
            },
            goToCreateTestList() {
                this.$router.push('/test-list/create')
            },
            fetchAllTestLists() {
                this.isFetchingTestLists = true
                testListService.getAllTestLists(this.page, this.size, this.sortKey, this.sortOrder).then(resp => {
                    this.testLists = resp.data.content
                    this.totalPages = resp.data.totalPages
                }).catch((error) => {
                    this.$emit('set-alert', error.response.data.message, 'error')
                }).finally(() => {
                    this.isFetchingTestLists = false
                })
            },
            updateTestList(testListIndex, property, val) {
                const testList = this.testLists.find(c => c.id === testListIndex)
                testList[property] = val
            },
            deleteTestList(id) {
                this.testLists = this.testLists.filter(testList => testList.id !== id)
            },
            setAlert(message, type) {
                this.showAlert = true
                this.alertMessage = message
                this.alertType = type
            },
            initializeFilters() {
                const query = this.$route.query
                if (query.page) this.page = parseInt(query.page)
                if (query.pageSize) this.size = parseInt(query.pageSize)
                if (query.sortKey) this.sortKey = query.sortKey
                if (query.sortOrder) this.sortOrder = query.sortOrder
            },
            applyFiltersToQuery() {
                const query = {
                    page: this.page,
                    pageSize: this.size,
                    sortKey: this.sortKey,
                    sortOrder: this.sortOrder
                }
                this.$router.replace({ query })
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px auto;
}

</style>
